<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Interfaces
      </div>
      <v-data-table
        :headers="headers"
        :items="dados"
        :search="search"
        multi-sort
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <div class="py-2 px-2 table_search_area">
              <v-text-field
                clearable
                hide-details=""
                clear-icon="close"
                v-model="search"
                outlined
                label="Busca"
              ></v-text-field>
            </div>
            <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="''">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="''">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">assignment</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para TXT</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <div class="ui-create">
      <v-btn color="primary" elevation="3" @click="dialogNovo = true" :loading="loading" :disabled="loading">
        <v-icon color="white" x-large>add</v-icon>
      </v-btn>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="600px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{interfaceDados.uuid_ite_id ? 'Editar' : 'Nova'}} interface
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formInterface">
          <v-row>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-menu
                ref="calendarData"
                v-model="calendarData"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    label="Data*"
                    :rules="[rules.required]"
                    append-icon="calendar_today"
                    :loading="salvando"
                    :disabled="salvando"
                    v-bind="attrs"
                    v-on="on"
                    v-model="dataFormatada"
                    v-mask="'##/##/####'"
                    @input="() => {
                      calendarData = false
                      interfaceDados.ite_data = $root.Formatter.parseDate(dataFormatada)
                      updatePickerModalData = $root.Formatter.parseDate(dataFormatada)
                    }"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :picker-date.sync="updatePickerModalData"
                  year-icon="calendar_today"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                  :loading="salvando"
                  :disabled="salvando"
                  v-model="data"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-text-field
                v-model="interfaceDados.ite_nsu"
                autofocus
                label="Nsu*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="vinculo"
                :items="vinculos"
                label="Vínculo*"
                @change="showVinculo(vinculo)"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando"
                :disabled="salvando"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-autocomplete
                v-if="selecionadoUsina"
                :menu-props="{ offsetY: true}"
                v-model="interfaceDados.uuid_usi_id"
                :items="usinas"
                clearable
                clear-icon="close"
                label="Usina*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando || loadingUsinas"
                :disabled="salvando || loadingUsinas"
                outlined
              >
              </v-autocomplete>
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="interfaceDados.uuid_uni_id"
                :items="unidades"
                clearable
                clear-icon="close"
                label="Unidade consumidora*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando || loadingUnidades"
                :disabled="salvando || loadingUnidades"
                outlined
                v-if="selecionadoUnidade"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="interfaceDados.uuid_int_id"
                :items="integradores"
                clearable
                clear-icon="close"
                label="Integrador*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando || loadingIntegradores"
                :disabled="salvando || loadingIntegradores"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <div class="text-h2 text-primary">
                Configuração do dispositivo
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0">
              <v-text-field
                v-model="interfaceDados.ite_usuario"
                label="Usuário"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0">
              <v-text-field
                v-model="interfaceDados.ite_senha"
                label="Senha"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditInterface()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Interface
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDialogDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Interface <b class="text-primary">{{interfaceDados.ite_id}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="cancelDialogDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeInterface()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
import moment from 'moment'
export default {
  data () {
    return {
      loading: true,
      salvando: false,
      dialogNovo: false,
      dialogExcluir: false,
      selecionadoUsina: false,
      selecionadoUnidade: false,
      vinculos: [
        {
          text: 'Usina',
          value: 1
        },
        {
          text: 'Unidade consumidora',
          value: 2
        }
      ],
      search: '',
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'ite_id'
        },
        { text: 'Data', value: 'ite_data' },
        { text: 'Usina', value: 'usina.usi_nome' },
        { text: 'Unidade consumidora', value: 'unidade.uco_nome' },
        { text: 'Nsu', value: 'ite_nsu' },
        { text: 'Usuário', value: 'ite_usuario' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      rules: {
        required: value => !!value || 'Obrigatório.'
      },
      data: '',
      dataFormatada: '',
      updatePickerModalData: '',
      calendarData: false,
      loadingIntegradores: false,
      integradores: [],
      loadingUsinas: false,
      loadingUnidades: false,
      usinas: [],
      unidades: [],
      vinculo: '',
      interfaceDados: {
        ite_data: '',
        ite_nsu: '',
        ite_usuario: '',
        ite_senha: '',
        uuid_usi_id: '',
        uuid_uni_id: '',
        uuid_int_id: ''
      }
    }
  },
  watch: {
    data () {
      this.dataFormatada = moment(this.data).format('L')
      this.interfaceDados.ite_data = this.$root.Formatter.parseDate(this.dataFormatada)
      this.calendarData = false
    }
  },
  methods: {
    loadFunctions () {
      this.getInterfaces()
      this.getIntegradores()
      this.getUsinas()
      this.getUnidades()
    },
    async getIntegradores () {
      this.loadingIntegradores = true
      await Api.get('integradores')
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          this.integradores = arrayInt
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradoes!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getUsinas () {
      this.loadingUsinas = true
      await Api.get('usinas')
        .then(res => {
          var arrayUsi = []
          res.data.map(usi => {
            arrayUsi.push({
              'text': usi.usi_nome,
              'value': usi.uuid_usi_id
            })
          })
          this.usinas = arrayUsi
          this.loadingUsinas = false
        })
        .catch(err => {
          this.loadingUsinas = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as usinas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getUnidades () {
      this.loadingUnidades = true
      await Api.get('unidades-consumidoras')
        .then(res => {
          var arrayUni = []
          res.data.map(uni => {
            arrayUni.push({
              'text': uni.uco_nome,
              'value': uni.uuid_uco_id
            })
          })
          this.unidades = arrayUni
          this.loadingUnidades = false
        })
        .catch(err => {
          this.loadingUnidades = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as unidades consumidoras!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getInterfaces () {
      this.loading = true
      await Api.get('interfaces')
        .then(res => {
          if (res.data.length) {
            res.data.map(item => {
              item.ite_data = item.ite_data ? moment(item.ite_data).format('DD/MM/YYYY') : ''
            })
          }
          this.dados = res.data
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as interfaces!',
            color: 'error'
          })
          console.log(err)
        })
    },
    openNovo (item) {
      this.salvando = true
      this.dialogNovo = true
      Api.get('interfaces/' + item.uuid_ite_id)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.interfaceDados = JSON.parse(JSON.stringify(response.data))
          if (response.data.usina) {
            this.showVinculo(1)
            this.interfaceDados.uuid_usi_id = response.data.usina.uuid_usi_id
          }
          if (response.data.unidade) {
            this.showVinculo(2)
            this.interfaceDados.uuid_uni_id = response.data.unidade.uuid_uco_id
          }
          if (response.data.integrador) {
            this.interfaceDados.uuid_int_id = response.data.integrador.uuid_int_id
          }
          this.data = response.data.ite_data
          if (this.data) {
            this.dataFormatada = moment(this.data).format('L')
            this.updatePickerModalData = this.$root.Formatter.parseDate(this.dataFormatada)
          }
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados da interface!',
            color: 'error'
          })
        })
    },
    showVinculo (item) {
      this.interfaceDados.uuid_uni_id = ''
      this.interfaceDados.uuid_usi_id = ''
      if (item === 1) {
        this.vinculo = 1
        this.selecionadoUsina = true
        this.selecionadoUnidade = false
      } else {
        this.vinculo = 2
        this.selecionadoUsina = false
        this.selecionadoUnidade = true
      }
    },
    closeDialog () {
      this.dialogNovo = false
      this.interfaceDados = {
        ite_data: '',
        ite_nsu: '',
        ite_usuario: '',
        ite_senha: '',
        uuid_usi_id: '',
        uuid_uni_id: '',
        uuid_int_id: ''
      }
      this.vinculo = ''
      this.selecionadoUsina = false
      this.selecionadoUnidade = false
      if (this.$refs.formInterface) {
        this.$refs.formInterface.resetValidation()
      }
    },
    saveEditInterface () {
      if (!this.$refs.formInterface.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'interfaces/novo'
      if (this.interfaceDados.uuid_ite_id) {
        endpoint = 'interfaces/edita'
      }
      Api.post(endpoint, this.interfaceDados)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.closeDialog()
          this.getInterfaces()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    openDialogDelete (item) {
      this.interfaceDados = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelDialogDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    removeInterface () {
      this.salvando = true
      Api.delete(`interfaces/remove/${this.interfaceDados.uuid_ite_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getInterfaces()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover interface!',
            color: 'error'
          })
        })
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.mw_600 {
  max-width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/pages/cadastros/Interface.vue